module.exports = __webpack_public_path__ + "static/media/logo-nuevo-bvc-w.afa4e0a1.png";